import { useMutation, useQueryClient } from '@tanstack/react-query';

import { putOfferingsOnTagByTagId } from '@arrived/api_v2';
import { OfferingsViaTagPutRequest, Tag } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { tagsByCategoryQueryKeyFn, tagsQueryKeyFn } from './tags.keys';

export function usePutOfferingsOnTagByTagIdMutation(options?: UseMutationOptions<Tag, OfferingsViaTagPutRequest>) {
  const queryClient = useQueryClient();

  return useMutation((offeringsViaTagPutRequest) => putOfferingsOnTagByTagId(offeringsViaTagPutRequest), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { uuid: tagId, category } = data;

      queryClient.invalidateQueries(tagsQueryKeyFn(tagId));

      if (category) {
        queryClient.invalidateQueries(tagsByCategoryQueryKeyFn(category));
      }

      options?.onSuccess?.(data, variables, context);
    },
  });
}
